import Record from '../Record'

export default class AEEEvent extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new AEEEvent({
				id: null,
				aee_id: null,
				event: null,
				event_d: Anvil.moment().format('YYYY-MM-DD'),
				invoice_issued: 0,
				notes: '',
				cost_bearer_company_id: null
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/c_order/aee_event/${id}`)
			return new AEEEvent(data)
		}
	}

	static async delete (id) {
        await Anvil.REST.delete(`/c_order/aee_event/${id}`)
	}

	async commit () {

		// Validate
		if (!this.validate()) {
			throw new Error('Kérjük ellenőrizze a megadott adatokat.')
		}

		if (this._data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/c_order/aee_event`, this._data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/c_order/aee_event/${this._data.id}`, this._data)
		}
	}

	validation_schema = {
		event: [ 'required' ],
		event_d: [ 'required' ]
	}
}